import React from 'react';

const WhatsAppFloat: React.FC = () => (
  <a
    href="https://api.whatsapp.com/send?phone=917065787678&text=Hi"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    style={{
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      zIndex: 9999,
      width: '56px',
      height: '56px',
      borderRadius: '50%',
      backgroundColor: '#25D366',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
      transition: 'transform 0.2s, box-shadow 0.2s',
      textDecoration: 'none',
    }}
    onMouseEnter={e => {
      (e.currentTarget as HTMLAnchorElement).style.transform = 'scale(1.1)';
      (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 6px 16px rgba(0,0,0,0.3)';
    }}
    onMouseLeave={e => {
      (e.currentTarget as HTMLAnchorElement).style.transform = 'scale(1)';
      (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 4px 12px rgba(0,0,0,0.25)';
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="30"
      height="30"
      fill="white"
    >
      <path d="M16 0C7.163 0 0 7.163 0 16c0 2.824.737 5.474 2.027 7.774L0 32l8.476-2.001A15.938 15.938 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 01-6.77-1.852l-.485-.289-5.03 1.187 1.213-4.918-.318-.503A13.267 13.267 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.878c-.398-.199-2.355-1.162-2.72-1.295-.365-.133-.631-.199-.897.199-.265.398-1.029 1.295-1.261 1.56-.232.266-.465.299-.863.1-.398-.199-1.682-.62-3.204-1.977-1.184-1.057-1.984-2.363-2.216-2.761-.232-.398-.025-.613.174-.811.179-.178.398-.465.597-.697.199-.232.265-.398.398-.664.133-.265.066-.497-.033-.697-.1-.199-.897-2.163-1.229-2.961-.324-.777-.653-.672-.897-.684l-.764-.013c-.265 0-.697.1-1.062.497-.365.398-1.394 1.362-1.394 3.32 0 1.958 1.427 3.85 1.626 4.115.199.265 2.806 4.285 6.797 6.01.95.41 1.691.655 2.269.838.953.303 1.82.26 2.506.158.764-.114 2.355-.963 2.688-1.894.332-.93.332-1.727.232-1.894-.099-.166-.365-.265-.763-.464z" />
    </svg>
  </a>
);

export default WhatsAppFloat;
